//css hash: 8e2808c08560db3d 
 export const input = "basic_form--input--c0T0l";
export const bigInput = "basic_form--bigInput--XpOVB basic_form--input--c0T0l";
export const textInput = "basic_form--textInput--6j7Y6";
export const labeledInputGroup = "basic_form--labeledInputGroup--oRR2z";
export const selectPlaceholder = "basic_form--selectPlaceholder--OMDch";
export const hoverLabel__hasValue = "basic_form--hoverLabel__hasValue--qHX2G";
export const labeledInputGroupDisabled = "basic_form--labeledInputGroupDisabled--hS2Df basic_form--labeledInputGroup--oRR2z";
export const hoverLabel = "basic_form--hoverLabel--w7kgn";
export const bigTextInput = "basic_form--bigTextInput--IQimY basic_form--textInput--6j7Y6 basic_form--bigInput--XpOVB basic_form--input--c0T0l";
export const label = "basic_form--label--nylQE";
export const bigSelect = "basic_form--bigSelect--n00gz basic_form--bigTextInput--IQimY basic_form--textInput--6j7Y6 basic_form--bigInput--XpOVB basic_form--input--c0T0l";
export const infoIcon = "basic_form--infoIcon--zblHl";
export const error = "basic_form--error--B3VYl";
